import React from 'react';
import ImageGallery from 'react-image-gallery';

const InventoryItem = ({item}) => {
    const pictures = item.pictures.split(',');
    const images = [];
    pictures.map((image) => {
        const galleryImage = {
            original: `https://naawebsitestorage.blob.core.windows.net/images/${item.id}/${image}`,
            originalAlt: `${item.name} for sale`,
            thumbnail: `https://naawebsitestorage.blob.core.windows.net/images/${item.id}/${image}`,
            thumbnailAlt:""
        }
        images.push(galleryImage);
    })

    return <div>
        <h2>{item.name}</h2>
        <div className="itemContent">
        <ImageGallery items={images}/>
        <div className="rightcol">
            <p className="top">{`Manufacturer: ${item.make}`}</p>
            <p>{`Model: ${item.model}`}</p>
            <p>{`Caliber: ${item.caliber}`}</p>
            <p>{`Condition: ${item.condition}`}</p>
            <p>{`Type: ${item.type}`}</p>
            <p className="itemId">{`Item Id: ${item.id}`}</p>
            <p className="price">{`$${item.price}`}</p>
            <div>
                <p>Like what you see? Call us at:</p>
                <a href="tel:8044544867">(804)454-GUNS</a>
            </div>
        </div>
    </div>
    <p>{item.description}</p>
</div>
}

export default InventoryItem;